import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import Recaptcha from 'services/recaptcha';
import { Session, SessionKeys } from 'common/services/-RFC.session.js';
import eventManager from 'common/services/-RFC.eventManager';

const _serviceDependencies = ['$scope', '$interval', 'Auth', 'Util', '$rootScope', 'Sso', '$window', '$state'];

/**
     * @ngdoc service
     * @name controllers.Login
     *
     * @description
     * Login controller
     */
class Login {

    /**
         * @param  {any} $scope
         * @param  {any} $interval
         * @param  {any} Auth
         * @param  {any} Util
         * @param  {any} rootScope
         * @param  {any} Sso
         * @param  {any} $window
         */
    constructor($scope, $interval, Auth, Util, $rootScope, Sso, $window, $state) {

        this.Auth = Auth;
        this.Util = Util;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.Sso = Sso;
        this.$window = $window;
        this.$interval = $interval;
        this.$scope.submitted = false;
        this.Auth.loading = false;
        this.Auth.error = false;
        this.$scope.emailRegExp = this.Util.getEmailValidationRegExp();
        this.$scope.showChangeLang = true;
        this.$scope.showSocialLogin = true;
        this.$scope.showEmbeddedSocialLogin = false;
        this.Recaptcha = Recaptcha;
        this.$scope.clientId = 'dashboard';
        this.$scope.activeSlide = 'slide-1';
        this.$scope.sliderAutoplay = true;
        this.$state = $state;
        this.$scope.brandName = CWCONFIG.partnerConfig.name;
        this.$scope.hrefEndUser = CWCONFIG.partnerConfig.translationsLinks.eula.endUserLicenseAgreement.replace('{language}', CWCONFIG.language);
        this.$scope.hrefLegalTerms = CWCONFIG.partnerConfig.translationsLinks.eula.legalTerms.replace('{language}', CWCONFIG.language);
        this.$scope.hrefGeneralPrivacy = CWCONFIG.partnerConfig.translationsLinks.generalPrivacy.replace('{language}', CWCONFIG.language);
        this.$scope.hrefGeneralImprint = CWCONFIG.partnerConfig.translationsLinks.generalImprint.replace('{language}', CWCONFIG.language);
        this.$scope.showSimplifiedLogin = false;
        const supportedLanguagesAwards = CWCONFIG.partnerConfig.translationsLinks.awards.languages;

        if (supportedLanguagesAwards.find(element => element === CWCONFIG.language)) {

            this.$scope.hrefAwards = CWCONFIG.partnerConfig.translationsLinks.awards.href.replace('{language}', CWCONFIG.language);

        } else {

            this.$scope.hrefAwards = CWCONFIG.partnerConfig.translationsLinks.awards.href.replace('{language}', 'en');

        }

        this.$scope.$parent.setCaptchaResponse = this.setCaptchaResponse.bind(this);

        const initialUrl = String(Session.getValue(SessionKeys.InitialUrl));

        this.socialLoginUrl = initialUrl;
        this.$scope.showCustomAuth = false;

        let mixpanelPayload = { Source: 'Direct' };

        let counter = 1;
        this.sliderInterval = this.$interval(() => {

            counter += 1;

            if (counter < 4) {

                this.switchSlide(`slide-${counter}`);

            } else {

                counter = 1;
                this.switchSlide(`slide-${counter}`);

            }

        }, 5000);

        // SSO thirParty login
        if (this.Sso.isThirdPartyLogin) {

            // hide change language button if we receive change_lang=false param in the url
            this.$scope.showChangeLang = this.Sso.getChangeLang();

            // show the back button if we receive a skip_uri param in the url
            this.skip_uri = this.Sso.getSkipUri();
            this.$scope.showSkipButton = this.skip_uri;

            // show the close button if we receive a close_button=true param in the url
            this.$scope.showCloseButton = this.Sso.getCloseButton();

            // hide the social login button if we receive a social_login=false param in the url
            this.$scope.showSocialLogin = this.Sso.getSocialLogin();

            // show the embedded social login button if we receive a embedded_social=true param
            this.$scope.showEmbeddedSocialLogin = this.Sso.getEmbeddedSocialLogin();

            this.$scope.clientId = this.Sso.getClientId();

            // prefill email address if we receive an email param
            // param should be 64base encoded
            this.$scope.email = this.isBase64();

            if (initialUrl.indexOf('client_id=spotlight') > -1) {

                /**
                 * Set the URL for the social button that will redirect to the Sso page
                 * in the browser with other default values
                 */
                const token = Util.getToken();
                // close the embedded sso page if sso token is missing
                if (!token || token === 'undefined') {

                    if (window.external && ('CloseHtml' in window.external)) {

                        window.external.CloseHtml('social login redirect to dashboard');

                    }

                }
                this.socialLoginUrl = this.socialLoginUrl
                    .replace('embedded_social=true', 'embedded_social=false')
                    .replace('social_login=false', 'social_login=true')
                    .replace('change_lang=false', 'change_lang=true')
                    .replace('embedded=true', 'embedded=false')
                    .replace(Util.getParams(initialUrl).access_token, token);

                // this means user landed in register page and switched tabs to register
                // so our redirect must now be to login
                if (this.socialLoginUrl.indexOf('auth/register') > -1) {

                    this.socialLoginUrl = this.socialLoginUrl.replace('auth/register', 'auth/login');

                }

                this.$scope.email = this.Sso.getEmailAddress() || '';

            }

        }
        // conditions in order to show simplified Login view :
        // exist an lastLogin obj in localstorage
        // link is not from spotlight ( doestn't contain 'embedded=true' )
        const lastLogin = localStorage.getItem('lastLogin');
        this.$scope.lastLogin = this.decodeLastLogin(lastLogin);

        if (this.$scope.lastLogin
                && this.$scope.lastLogin.loginType
                && this.socialLoginUrl.indexOf('embedded=true') === -1) {

            const isSocialLoginAvailable = (this.$scope.lastLogin.loginType === 'fb_auth' && this.$scope.fb.feature)
                || (this.$scope.lastLogin.loginType === 'gg_auth' && this.$scope.gplus.feature)
                || (this.$scope.lastLogin.loginType === 'apl_auth' && this.$scope.appleID.feature && this.$scope.browserName !== 'ie');

            if (this.$scope.lastLogin.loginType === 'password') {

                this.$scope.showSimplifiedLogin = true;
                this.$scope.email = this.$scope.lastLogin.email;

            } else {

                this.$scope.showSimplifiedLogin = isSocialLoginAvailable;

            }

        }

        if ($rootScope.isFromSpotlightNewsletterCampaign === true) {

            mixpanelPayload = { Source: 'ws_spotlight' };

        }

        Mixpanel.setCommonProperty('Simplified Login', this.$scope.showSimplifiedLogin);
        Mixpanel.send('ConnectWeb Auth Login Open', mixpanelPayload);

        this.$scope.$on('$destroy', () => {

            if (this.$scope.showCustomAuth) {

                angular.element('.landing-page-auth').show();

            }

        });

    }

    switchLoginView() {

        this.$scope.showSimplifiedLogin = false;
        let lastLoginType;
        switch (this.$scope.lastLogin.loginType) {

        case 'gg_auth':
            lastLoginType = 'Google';
            break;
        case 'fb_auth':
            lastLoginType = 'Facebook';
            break;
        case 'apl_auth':
            lastLoginType = 'Apple ID';
            break;
        case 'password':
            lastLoginType = 'Password';
            break;
        default:
            lastLoginType = '';

        }
        Mixpanel.send('ConnectWeb Other Login Options Click', {
            'Last Login': lastLoginType,
        });


    }

    isBase64() {

        try {

            return this.Sso.getDecodedEmailAddress();

        } catch (err) {

            return '';

        }

    }

    // SSO skip the login and redirect to skip_uri received in params
    skip() {

        Mixpanel.send('ConnectWeb Skip Click', {
            Page: 'Auth Login',
        });

        this.$window.location = this.skip_uri;

    }

    login() {

        // errors from authentification are hidden on start of form submission
        this.Auth.error = false;

        const oauthPayload = {
            grant_type: 'password',
            username: this.$scope.email,
            password: this.$scope.password,
        };

        const headers = {
            'X-Avira-Token': this.Auth.getTfaCookie(),
        };

        const captchaRespose = this.Recaptcha.getCaptchaResponse();

        if (captchaRespose) {

            headers['X-Avira-Captcha-Token'] = captchaRespose;

        }

        // Check if the user email and password are valid
        const formIsValid = this.$scope.loginForm.$valid;


        Mixpanel.send('ConnectWeb Login Click', {
            Page: 'Auth Login',
        });

        this.$scope.submitted = true;

        let mixpanelError = '';

        if (formIsValid) {

            this.Auth.loading = true;
            this.Auth.loginType = 'Login'; // Login type for mixpanel event
            this.Auth.login(oauthPayload, headers);

        } else {

            this.Util.triggerAnimation('.error', 'animated shake');

            if (this.$scope.loginForm.email.$invalid) {

                if (typeof this.$scope.loginForm.email.$viewValue === 'undefined' ||
                    this.$scope.loginForm.email.$viewValue === '') {

                    mixpanelError += 'email is empty, ';

                } else {

                    mixpanelError += 'email format not correct, ';

                }

            }

            if (this.$scope.loginForm.password.$invalid) {

                if (typeof this.$scope.loginForm.password.$viewValue === 'undefined' ||
                    this.$scope.loginForm.password.$viewValue === '') {

                    mixpanelError += 'password is empty, ';

                } else {

                    mixpanelError += 'password format not correct, ';

                }

            }

            Mixpanel.send('ConnectWeb Login Error', {
                'Error Name': mixpanelError.replace(/,\s*$/, ''), // remove last ',' and ' '
            });

        }

    }

    onSubmit() {

        if (this.Recaptcha.captchaRetries <= this.Auth.failedLogins) {

            this.Recaptcha.enableCaptcha();

        }

        if (this.Recaptcha.isCaptchaRequired()) {

            this.Recaptcha.execute();

        } else if (this.$scope.clientId === 'centercode') {

            Mixpanel.send('ConnectWeb Login Confirmation Modal Open');
            this.$state.go('root.auth.login.ltb', {
                ltb: 'confirm-login',
            });

        } else {

            this.login();

        }
        eventManager.subscribe('confirm-login:true', () => {

            this.login();

        });

    }

    setCaptchaResponse(response) {

        this.Recaptcha.setCaptchaResponse(response);
        this.login();

    }

    setEmail() {

        this.$rootScope.forgotEmail = this.$scope.email;

    }

    // redirect from Spotlight to dashboard Sso in the default browser of the user
    socialLoginRedirect() {

        if (window.external && ('OpenUrl' in window.external)) {

            window.external.OpenUrl(this.socialLoginUrl);

        } else {

            window.open(this.socialLoginUrl, '_blank');

        }

        if (window.external && ('CloseHtml' in window.external)) {

            window.external.CloseHtml('social login redirect to dashboard');

        }

    }

    // animation switch slide

    switchSlide(currentSlide) {

        this.$scope.activeSlide = currentSlide;

    }

    stopAutoPlay() {

        this.$interval.cancel(this.sliderInterval);

    }

    decodeLastLogin(value) {

        if (value) {

            try {

                return JSON.parse(this.Util.base64decode(value));

            } catch (err) {

                const encodedLastLogin = this.Util.base64encode(value);
                localStorage.setItem('lastLogin', encodedLastLogin);
                return JSON.parse(value);

            }

        }

        return null;

    }

}

_serviceDependencies.push(Login);

angular.module('controllers')
    .controller('Login', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/auth/login/login.js